import React, { useEffect, useRef, useState } from "react";
import CLOUDS from "vanta/dist/vanta.clouds.min";
import "../styles/vanta.css";
import CanvasLines from "./CanvasLines";
import { AnimatePresence, motion } from "framer-motion";
import { useCookies } from "react-cookie";

const Vanta = () => {
  const [vantaEffect, setVantaEffect] = useState(null);
  const [showCursor, setShowCursor] = useState(false);
  const [typedTextIndex, setTypedTextIndex] = useState(0);
  const [backward, setBackward] = useState(false); // New state to track backward typing
  const profession = [
    "Web Developer.",
    "React Developer.",
    "MERN Stack Developer.",
    "Full Stack Developer.",
    "UI/UX Designer.",
    "Android Developer.",
    "Freelancer.",
  ];

  const [professionIndex, setProfessionIndex] = useState(1);
  const professionRef = useRef(profession[0]);

  const myRef = useRef(null);

  const [cookies, setCookie] = useCookies(["theme"]);

  const detectSystemTheme = () => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      return "dark";
    } else {
      return "light";
    }
  };

  const changeProfession = () => {
    setProfessionIndex((professionIndex + 1) % profession.length);
    professionRef.current = profession[professionIndex];
    setTypedTextIndex(0); // Reset typed text index when changing profession
    setBackward(false); // Reset backward typing
  };

  useEffect(() => {
    let themeForVanta;
    if (cookies.theme) {
      themeForVanta = cookies.theme;
    } else {
      themeForVanta = "dark";
    }
    if (themeForVanta === "system") {
      themeForVanta = detectSystemTheme();
    }
    if (!vantaEffect) {
      setVantaEffect(
        CLOUDS({
          el: myRef.current,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          ...(themeForVanta === "dark" && {
            backgroundColor: 0x0,
            skyColor: 0x3b3b3b,
            cloudColor: 0x111113,
            cloudShadowColor: 0x606060,
            sunColor: 0xffffff,
            sunGlareColor: 0xccc3c3,
            sunlightColor: 0xe3e3e3,
          }),
        })
      );
    }
    return () => {
      if (vantaEffect) {
        vantaEffect.destroy();
        setVantaEffect(null);
      }
    };
  }, [vantaEffect, cookies.theme]);

  useEffect(() => {
    if (showCursor) {
      const timeout = setTimeout(() => {
        if (!backward) {
          if (typedTextIndex < professionRef.current.length) {
            setTypedTextIndex((prevIndex) => prevIndex + 1);
          } else {
            // Delay before starting backward typing
            setTimeout(() => {
              setBackward(true);
            }, 500); // Adjust the delay time as needed
          }
        } else {
          if (typedTextIndex > 0) {
            setTypedTextIndex((prevIndex) => prevIndex - 1);
          } else {
            changeProfession();
            setBackward(false);
          }
        }
      }, 50); // Typing speed

      return () => clearTimeout(timeout);
    }
  }, [showCursor, typedTextIndex, backward]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowCursor(true);
    }, 1000); // Delay before starting typing effect

    return () => clearTimeout(timeout);
  }, []);

  const typedText = professionRef.current.substring(0, typedTextIndex);

  return (
    <AnimatePresence>
      <div className="vanta">
        <div className="clouds" ref={myRef}>
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -30, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="about"
          >
            <div className="title">
              <div>
                <span className="subtitle">Hey, Here is</span>
              </div>
              <h1>
                <span>C</span>heegiti <span>M</span>ahesh
              </h1>
              <div className="profession">
                <span className="subtitle">
                  I'm a <span>{typedText}</span>
                </span>
                <span className="cursor">{showCursor && "|"}</span>
              </div>
            </div>
          </motion.div>
          <CanvasLines />
        </div>
      </div>
    </AnimatePresence>
  );
};

export default Vanta;
